// ユーザーの追加（portal.md「ユーザー管理」/ portal-api.md POST /contracts/{contractId}/users）。メンバー画面のポップアップの中身。
// 招待メールは送らない。送るのはメンバー一覧で選んで「招待メールを送る」（ADR-0027）。

import { useState } from "react";
import { api, messageFor, type Role, type ContractRows } from "../lib/api";
import { EMAIL_RE } from "../lib/login";
import { RoleSelect, ServiceAccess, TeamChecks } from "./shared";

/** 続けて追加できるよう、追加後もフォームを空にして開いたままにする。onChanged は一覧を更新するため。 */
export function AddUserPanel({ contractId, rows, onChanged }: { contractId: string; rows: ContractRows; onChanged: () => void }) {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState<Role>("member");
  const [teams, setTeams] = useState<string[]>([]);
  const [services, setServices] = useState<Record<string, boolean>>({});
  const [error, setError] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const add = async (e: React.FormEvent) => {
    e.preventDefault();
    const v = email.trim().toLowerCase();
    if (!EMAIL_RE.test(v)) { setError("メールアドレスの形式が正しくありません。"); return; }
    setBusy(true); setError(null); setNotice(null);
    try {
      await api.addUser(contractId, { email: v, role, teams, services: Object.keys(services).length ? services : undefined });
      setNotice(`${v} を追加しました。招待メールはまだ送っていません。`);
      setEmail(""); setRole("member"); setTeams([]); setServices({});
      onChanged();
    } catch (err) { setError(messageFor(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={add}>
      <label htmlFor="add-email">メールアドレス</label>
      <input id="add-email" type="email" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
      <label>権限（この契約でのポータル操作権限）</label>
      <RoleSelect value={role} onChange={setRole} />
      <label>所属チーム（任意。複数可）</label>
      {rows.teams.length === 0 ? <p className="muted">チームはまだありません。チームを使わなくても追加できます。</p> : <TeamChecks teams={rows.teams} value={teams} onChange={setTeams} />}
      <label>サービス使用可否（サービス利用が有効なサービスだけ設定できます）</label>
      <ServiceAccess subscriptions={rows.subscriptions} contractName={rows.contract.name} value={services} onChange={setServices} />
      <p className="note"><span aria-hidden>ⓘ</span><span>本人へのログイン案内は一覧から「招待メールを送る」で送ってください。SSO の人はメールを送らなくてもログインすれば利用を始められます。</span></p>
      {error && <p className="error">{error}</p>}
      {notice && <p className="ok">{notice}</p>}
      <p className="row modal-actions"><span className="spacer" /><button className="primary" type="submit" disabled={busy}>{busy ? "処理中…" : "追加する"}</button></p>
    </form>
  );
}
